<template>
  <v-dialog v-model="value" persistent width="500">
    <v-card>
      <v-card-title>
        <span class="title">{{ text }}</span>
      </v-card-title>
      <v-card-actions>
        <v-btn small class="primary" @click="$emit('confirm')">
          Ok
        </v-btn>
        <v-btn small @click="$emit('cancel')">
          Відмінити
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["value", "text"],
};
</script>
